export default {
  name: 'tenant-registration',
  translationKey: 'tenant-registration-module',
  routePrefix: '',
  routeNamePrefix: 'tenant-registration',
  directRoutesAvailable: true,
}
